import type { TenantPublicResponse } from "@/types";

const tenantProfileCacheKey = (slug: string): string =>
  `tenant_profile_${slug}`;

export const readTenantProfileCache = (
  slug: string,
): TenantPublicResponse | null => {
  try {
    const raw = localStorage.getItem(tenantProfileCacheKey(slug));

    if (!raw) {
      return null;
    }

    return JSON.parse(raw) as TenantPublicResponse;
  } catch {
    return null;
  }
};

export const writeTenantProfileCache = (
  slug: string,
  profile: TenantPublicResponse,
): void => {
  try {
    localStorage.setItem(tenantProfileCacheKey(slug), JSON.stringify(profile));
  } catch {
    /* storage unavailable */
  }
};
